import { Text } from "@mantine/core";

import type { SalesOpportunitiesMetricsView } from "../data/types";

import salesOpportunitiesIcon from "./assets/salesOpportunitiesIcon.png";
import styles from "./cardContent.module.css";
import { computeDirectRingFill } from "./computeRingFill";
import { MetricCard } from "./MetricCard";
import { RingArt } from "./RingArt";
import { SALES_OPPORTUNITIES_GRADIENT, SALES_TARGET } from "./targets";

interface Props {
    view: SalesOpportunitiesMetricsView;
}

export function SalesOpportunitiesCard({ view }: Props) {
    const sales = view.sales;
    const hasSales = sales !== null;
    const ringProgress = hasSales ? computeDirectRingFill(sales, SALES_TARGET) : 0;
    const targetUnit = SALES_TARGET === 1 ? "sale" : "sales";

    return (
        <MetricCard
            title="Sales and opportunities"
            isLoading={view.isLoading}
            isEmpty={!hasSales}
            emptyValue="No sales data yesterday."
            art={
                <RingArt progress={ringProgress} gradient={SALES_OPPORTUNITIES_GRADIENT} isLoading={view.isLoading}>
                    <img src={salesOpportunitiesIcon} alt="" className={styles.icon} />
                </RingArt>
            }
            value={
                <Text component="span" className={styles.bigNumber}>
                    {sales}
                </Text>
            }
            footer={
                <>
                    Sales target{" "}
                    <strong>
                        ({SALES_TARGET} {targetUnit})
                    </strong>
                </>
            }
        />
    );
}
